export default "/_next/static/chunks/fonts/WhitneySSm-BoldItalic-Pro_Web-b6b299725b383ef1cdbd1e7d94b9e3cb.woff2";